import GoingUtils from "@/utils/goingUtils";


/**
 * 注册表格事件
 * @param gridKey
 * @param funType
 * @param fun
 */
export function regeditEngineEvent(gridKey,funType,fun){
  if((window as any).FunctionEngine){
    (window as any).FunctionEngine[funType+gridKey]=fun;
    if(GoingUtils.getPageCode()){
      const funName=GoingUtils.getPageCode()+"_"+funType+gridKey;
      (window as any).FunctionEngine[funName]=fun;
    }else{
      (window as any).FunctionEngine[funType+gridKey]=fun;
    }
  }
}


export function executeEngineEvent(gridKey,funType){
    if((window as any).FunctionEngine){
      const funName=GoingUtils.getPageCode()+"_"+funType+gridKey;
      if((window as any).FunctionEngine[funName]){
        return  (window as any).FunctionEngine[funName]&&(window as any).FunctionEngine[funName]();
      }
     return  (window as any).FunctionEngine[funType+gridKey]&&(window as any).FunctionEngine[funType+gridKey]();
    }
}

export function executeUserFun(funType,inParams){

}

export function removeEngineEvent(gridKey,funType){
  if((window as any).FunctionEngine&&(window as any).FunctionEngine[funType+gridKey]){
    (window as any).FunctionEngine[funType+gridKey]=null;
    delete (window as any).FunctionEngine[funType+gridKey];
  }
}
/**
 * 表格选中数据 执行操作
 * @param selRecords
 * @param gridKey
 */
export function executeSelRecordFun(selRecords,gridKey){
  //用于已选列表
  if((window as any).FunctionEngine['selRecordToList'+gridKey]){
    (window as any).FunctionEngine['selRecordToList'+gridKey](selRecords);
  }
}

/**
 * 执行表单校验
 * @param okFun
 * @param errorFun
 */
export function executeValidateForm(okFun, errorFun,pageContentElKey){
  if((window as any).FunctionEngine['validateFormObj']){
    (window as any).FunctionEngine['validateFormObj'](okFun, errorFun,pageContentElKey)
  }
}

/**
 * 执行删除记录操作
 */
export function executeDelRecordListFun(list,gridObj){
  if(gridObj&&(window as any).FunctionEngine['delGridRecord'+unref(gridObj).value]){
    (window as any).FunctionEngine['delGridRecord'+unref(gridObj).value](list);
  }
}
